import { TextAreaInput } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { VoiceTransferFormValues } from "../../types";

export const WhenToUseSection: React.FC = () => {
  const { t } = useTranslations();
  const { control } = useFormContext<VoiceTransferFormValues>();

  return (
    <CRMInfoSection
      title={t({
        id: "client-support-page.when-to-use",
        defaultMessage: "When to use",
      })}
      subtitle={t({
        id: "client-support-page.when-to-use-transfer-description",
        defaultMessage: "Brief instructions when to transfer the call",
      })}
    >
      <Controller
        control={control}
        name="when_to_handover"
        render={({ field: { value, onChange, ref } }) => (
          <TextAreaInput
            classNames={{
              wrapperClassName: "w-full",
              inputClassName:
                "min-h-[160px] max-h-[320px] overflow-y-auto jugl__custom-scrollbar",
            }}
            ref={ref}
            value={value}
            onChange={(event) => onChange(event.target.value.trimStart())}
            placeholder={[
              t({
                id: "client-support-page.when-to-use-transfer-tip-1",
                defaultMessage: "When Customer asks to speak to human manager",
              }),
              t({
                id: "client-support-page.when-to-use-transfer-tip-2",
                defaultMessage:
                  "Low confidence in intent or repeated misunderstandings",
              }),
              t({
                id: "client-support-page.when-to-use-transfer-tip-3",
                defaultMessage:
                  "Multiple products, custom pricing, unusual shipping, special requests",
              }),
              t({
                id: "client-support-page.when-to-use-transfer-tip-4",
                defaultMessage:
                  "Returns, refunds, account verification, payment issues, warranty claims",
              }),
              t({
                id: "client-support-page.when-to-use-transfer-tip-5",
                defaultMessage:
                  "Customer expresses frustration, urgency, or dissatisfaction",
              }),
            ]
              .map((tip) => `• ${tip}`)
              .join("\n")}
          />
        )}
      />
    </CRMInfoSection>
  );
};
